// console.log('custom-product.js');
$(function () {

  /*
  商品:サイズガイド
  */
  var sizeguidemodal_scrollY = 0;
  $(".js-sizeguidemodal-open").on("click", function(){
    console.log("click");
    sizeguidemodal_scrollY = window.scrollY;
    $("body").addClass("is-sizeguidemodal-open");
    $(".js-sizeguidemodal-wrap").fadeIn(100);
  });
  $(".js-sizeguidemodal-close").on("click", function(){
    $("body").removeClass("is-sizeguidemodal-open");
    $("html,body").scrollTop(sizeguidemodal_scrollY);
    $(".js-sizeguidemodal-wrap").css("display", "none");
  });
  $(".js-tabbtn button").click(function(){
    var target = $(this).data("target");
    $(".js-tabbtn button").removeClass("is-active");
    $('.js-tabbtn button[data-target="' + target + '"]').addClass("is-active");
    $(".js-tab-content").hide(), $('.js-tab-content[data-target="' + target + '"]').show();
  });

  /*
  商品:スライダー
  */
  const sliderThumb = new Swiper('#js-swiper-thumb', {
    loop: true,
    slidesPerView: 6.3,
    spaceBetween: 5,
    centeredSlides: false,
    slideToClickedSlide: false,
    breakpoints: {
      960: {
        slidesPerView: 10,
      }
    }
  });
  const sliderMain = new Swiper('#js-swiper-main', {
    loop: true,
    autoHeight: false,
    centeredSlides: true,
    slidesPerView: 1,
    spaceBetween: 5,
    navigation: {
      nextEl: '.swiper-button-next',
      prevEl: '.swiper-button-prev',
    },
    thumbs: {
      swiper: sliderThumb,
    },
    breakpoints: {
      960: {
        slidesPerView: 1,
      }
    }
  });
  // 操作中はスクロール禁止
  const swiperContainer = document.querySelector('#js-swiper-main');
  let startX = 0;
  let startY = 0;
  let isSwiping = false;
  swiperContainer.addEventListener('touchstart', function(e) {
    startX = e.touches[0].clientX;
    startY = e.touches[0].clientY;
    isSwiping = false;
  }, { passive: false });
  swiperContainer.addEventListener('touchmove', function(e) {
    const deltaX = e.touches[0].clientX - startX;
    const deltaY = e.touches[0].clientY - startY;
    if (!isSwiping) {
      if (Math.abs(deltaX) > Math.abs(deltaY)) {
        isSwiping = true;
        swiperContainer.style.touchAction = 'pan-x';
      } else {
        swiperContainer.style.touchAction = 'auto';
      }
    }
    if (isSwiping) {
      e.preventDefault();
    }
  }, { passive: false });
  swiperContainer.addEventListener('touchend', function() {
    swiperContainer.style.touchAction = 'auto';
  });

  /*
  商品:下部固定カート
  */
  $(window).on('scroll resize', function(){
    var buybutton = $('.js-product-buybutton');
    var fixcart = $('.js-product-fixcart');

    if (buybutton.length === 0 || fixcart.length === 0) return;

    var buybuttonBottom = buybutton.offset().top + buybutton.outerHeight();
    var scrollTop = $(window).scrollTop();
    
    if (scrollTop > buybuttonBottom) {
      fixcart.addClass('is-show');
    } else {
      fixcart.removeClass('is-show');
    }
  });
});